import React from 'react';
import PropTypes from 'prop-types';
import PieChart from './charts/PieChart';

const NeuroChart = ({ config }) => {
  const { type, keys, data, metrics, colors, isInteractive, ...restConfig } = config;
  let chart = '';

  switch(type) {
    case 'Pie':
      chart = (
        <PieChart 
          keys={keys} 
          data={data} 
          metrics={metrics} 
          colors={colors} 
          isInteractive={isInteractive}
          {...restConfig}
        />
      );
      break;
    default:
      chart = (<div>Chart not available.</div>);
  }

  return (
    <div className="chart">
      {chart}
    </div>
  );
};

NeuroChart.propTypes = {
  config: PropTypes.shape({
    type: PropTypes.string.isRequired,
    keys: PropTypes.array,
    data: PropTypes.array.isRequired,
    metrics: PropTypes.object,
    colors: PropTypes.object,
    isInteractive: PropTypes.bool,
  }).isRequired
};

export default NeuroChart;

